import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import "$components/**/*.{js,jsx,js.rb,css}"

const initContactForm = () => {
  const form = document.querySelector("#contact-form")
  if (!form) return

  const successEl = document.querySelector("#contact-success")
  const errorEl = document.querySelector("#contact-error")
  const submitButton = form.querySelector("button[type='submit']")

  const showSuccess = () => {
    form.classList.add("hidden")
    successEl?.classList.remove("hidden")
  }

  if (new URLSearchParams(window.location.search).get("sent") === "1") {
    showSuccess()
    return
  }

  form.addEventListener("submit", async (event) => {
    event.preventDefault()
    if (submitButton) submitButton.disabled = true
    errorEl?.classList.add("hidden")

    const formData = new FormData(form)
    formData.set("page", window.location.pathname)

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      })

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`)
      }

      showSuccess()
    } catch (error) {
      console.error(error)
      errorEl?.classList.remove("hidden")
      if (submitButton) submitButton.disabled = false
    }
  })
}

document.addEventListener("DOMContentLoaded", () => {
  initContactForm()
})
